import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import { Button, Grid, Link } from "@material-ui/core";
import Text from "../Text/Text";
import { useDispatch, useSelector } from "react-redux";
import { hidePrivacyPolicyModal } from "../../store/login/action";

const useStyles = makeStyles({
  heading: {
    fontWeight: 700,
  },
  leftGutter: {
    paddingLeft: 35,
  },
});
const PrivacyPolicy = (props) => {
  const store=useSelector(state=>state["loginState"]);
  const dispatch=useDispatch();
  const handleOk=()=>{
      dispatch(hidePrivacyPolicyModal())
  }
  const classes = useStyles();
  return (
    <>
      <Dialog open={store && store.privacyPolicyModalYN} fullWidth>
        <Grid container xs={12} md={12} spacing={2}>
          <DialogContent className={classes.heading}>
            <Grid item xs={12} md={12}>
              <Text variant="h6" gutterBottom className={classes.heading}>
                What information do we collect?
              </Text>
              <Text gutterBottom>
                We collect information from you when you place an order or fill
                out a form. When ordering or registering on our site, as
                appropriate, you may be asked to enter your: name, e-mail
                address, mailing address, phone number or credit card
                information.
              </Text>
              <Text variant="h6" gutterBottom className={classes.heading}>
                What do we use your information for?
              </Text>
              <Text gutterBottom>
                Any of the information we collect from you may be used in one of
                the following ways:
              </Text>
              <Text gutterBottom>
                <ol>
                  <li>
                    <Text gutterBottom>To process transactions</Text>
                    <Text gutterBottom className={classes.leftGutter}>
                      Your information, whether public or private, will not be
                      sold, exchanged, transferred, or given to any other
                      company for any reason whatsoever, without your consent,
                      other than for the express purpose of delivering the
                      purchased product or service requested.
                    </Text>
                  </li>
                  <li>
                    <Text gutterBottom>To send periodic emails</Text>
                    <Text gutterBottom className={classes.leftGutter}>
                      The email address you provide for order processing, will
                      only be used to send you information and updates
                      pertaining to your order.
                    </Text>
                  </li>
                </ol>
              </Text>
              <Text variant="h6" className={classes.heading} gutterBottom>
                How do we protect your information?
              </Text>
              <Text gutterBottom>
                We implement a variety of security measures to maintain the
                safety of your personal information when you place an order.
              </Text>
              <Text gutterBottom>
                We offer the use of a secure server. All supplied
                sensitive/credit information is transmitted via Secure Socket
                Layer (SSL) technology and then encrypted into our Payment
                gateway providers database only to be accessible by those
                authorized with special access rights to such systems, and are
                required to keep the information confidential.
              </Text>
              <Text gutterBottom>
                After a transaction, your private information (credit cards,
                social security numbers, financials, etc.) will not be stored on
                our servers.
              </Text>
              <Text variant="h6" gutterBottom className={classes.heading}>
                Do we use cookies? What is a cookie?
              </Text>
              <Text gutterBottom>
                Cookies are small text files that are stored on your computer’s
                hard drive by websites you visit. This website makes use of
                cookies that help us analyze how you use the website by
                monitoring which pages you find useful and which you do not.
                This allows us to tailor the website’s operations to your needs,
                likes and dislikes by gathering and remembering information
                about your preferences. The cookies we use in no way give us
                access to your computer or any personal information about you,
                other than the data you choose to share with us. Most browsers
                automatically accept cookies and you should be able to accept,
                delete or reject them if you wish by adjusting the settings on
                your browser. This will, however, affect your use of this
                website.
              </Text>
              <Text gutterBottom>
                This website makes use of the following cookies:
              </Text>
              <ol>
                <li>
                  <Text>
                    <span className={classes.heading}>
                      Permitsales.net cookies:
                    </span>
                    We use cookies only to track your active permit order
                    session. In all cases these cookies do not store any
                    information that makes you personally identifiable to us.
                  </Text>
                </li>
                <li>
                  <Text gutterBottom>
                    <span className={classes.heading}>
                      Google Analytics cookies:
                    </span>
                    We use the free Google Analytics tool (see
                    <Link
                      href="http://www.google.com/analytics"
                      target="blank"
                      style={{ textDecoration: "underline" }}
                    >
                      {" "}
                      http://www.google.com/analytics/
                    </Link>{" "}
                    ) to collect and analyze site statistics. Google Analytics
                    mainly uses first-party cookies to report on visitor
                    interactions on this website. These cookies do not collect
                    any personally identifiable information and are only used
                    for the statistical collection of data such as visits and
                    page hits. Google Analytics’ cookies store IP addresses but
                    we cannot link those addresses to any individual or path
                    through the website. Google uses the cookies to read
                    information and evaluate visitors' use of the website in the
                    form of statistical reports that we can access. The Google
                    Analytics' code is incorporated into this website’s code so
                    that our site serves the cookies, but Google has access to
                    the cookies. You can stop being tracked by Google Analytics
                    across all websites by going to{" "}
                    <Link style={{ textDecoration: "underline" }}>
                      {" "}
                      Google's site located here
                    </Link>
                    .
                  </Text>
                  <Text className={classes.leftGutter}>
                    This website uses Google Analytics, a web analytics service
                    provided by Google, Inc. ("Google"). Google Analytics uses
                    "cookies", which are text files placed on your computer, to
                    help the website analyze how users use the site. The
                    information generated by the cookie about your use of the
                    website (including your IP address) will be transmitted to
                    and stored by Google on servers in the United States. Google
                    will use this information for the purpose of evaluating your
                    use of the website, compiling reports on website activity
                    for website operators and providing other services relating
                    to website activity and internet usage. Google may also
                    transfer this information to third parties where required to
                    do so by law, or where such third parties process the
                    information on Google’s behalf. Google will not associate
                    your IP address with any other data held by Google. You may
                    refuse the use of cookies by selecting the appropriate
                    settings on your browser, however please note that if you do
                    this you may not be able to use the full functionality of
                    this website. By using this website, you consent to the
                    processing of data about you by Google in the manner and for
                    the purposes set out above. You can also read{" "}
                    <Link style={{ textDecoration: "underline" }}>
                      Google's Privacy Policy for Google Analytics
                    </Link>
                    .
                  </Text>
                </li>
              </ol>
              <Text variant="h6" gutterBottom className={classes.heading}>
                Do we disclose any information to outside parties?
              </Text>
              <Text gutterBottom>
                We do not sell, trade, or otherwise transfer to outside parties
                your personally identifiable information. This does not include
                trusted third parties who assist us in operating our website,
                conducting our business, or servicing you, so long as those
                parties agree to keep this information confidential. We may also
                release your information when we believe release is appropriate
                to comply with the law, enforce our site policies, or protect
                ours or others rights, property, or safety. However,
                non-personally identifiable visitor information may be provided
                to other parties for marketing, advertising, or other uses.
              </Text>
              <Text variant="h6" className={classes.heading} gutterBottom>
                California Online Privacy Protection Act Compliance
              </Text>
              <Text gutterBottom>
                Because we value your privacy we have taken the necessary
                precautions to be in compliance with the California Online
                Privacy Protection Act. We therefore will not distribute your
                personal information to outside parties without your consent.
              </Text>
              <Text variant="h6" gutterBottom className={classes.heading}>
                Childrens Online Privacy Protection Act Compliance
              </Text>
              <Text gutterBottom>
                We are in compliance with the requirements of COPPA (Childrens
                Online Privacy Protection Act), we do not collect any
                information from anyone under 13 years of age. Our website,
                products and services are all directed to people who are at
                least 13 years old or older.
              </Text>
              <Text variant="h6" gutterBottom className={classes.heading}>
                Online Privacy Policy Only
              </Text>
              <Text gutterBottom>
                This online privacy policy applies only to information collected
                through our website and not to information collected offline.
              </Text>
              <Text variant="h6" gutterBottom className={classes.heading}>
                Your Consent
              </Text>
              <Text gutterBottom>
                By using our site, you consent to our websites privacy policy.
              </Text>
              <Text variant="h6" gutterBottom className={classes.heading}>
                Changes to our Privacy Policy
              </Text>
              <Text gutterBottom>
                If we decide to change our privacy policy, we will post those
                changes on this page.
              </Text>
              <Text gutterBottom>
                This policy was last modified on 6/27/2013
              </Text>
              <Text gutterBottom variant="h6" className={classes.heading}>
                Contacting Us
              </Text>
              <Text gutterBottom>
                If there are any questions regarding this privacy policy you may
                contact us using the information below.
              </Text>
              <Text>
                <Link href="http://manager.permitsales.net">
                  http://manager.permitsales.net
                </Link>
              </Text>
              <Text>700 Phoenix Lake Avenue</Text>
              <Text>Streamwood, Illinois 60107</Text>
              <Text>USA</Text>
            </Grid>
          </DialogContent>
        </Grid>
        <DialogActions>
            <Button variant="contained" color="primary" onClick={handleOk}>Ok</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PrivacyPolicy;
